/* eslint-disable eqeqeq */
import React, { useContext, useMemo, useState } from "react";
import { Theme } from "@rjsf/bootstrap-4";
import { withTheme, utils } from "@rjsf/core";
import { getCokkie } from "../../../login/Login";
import { Button, Progress } from "reactstrap";
import { alertContext } from "../../../../components/modal/ModalComponent";
import useFetch from "../../../../components/useFetch";
import Loader from "../../../../components/Loader";
import Configuration from "../../../../components/modal/NavPanes/Configuration";
import ErrorScreen from "../../../../components/error/ErrorScreen";

import { Upload } from "@aws-sdk/lib-storage";
import { S3Client } from "@aws-sdk/client-s3";
import { CustomWidget } from "../../../../components/widgets/CustomWidgets";
import {
  ArrowRightIcon,
  BackIcon,
  CheckCircleIcon,
  CloseIcon,
  ExportIcon,
  UploadIcon,
} from "../../../Common/SvgIcons/WorkflowIcons";
import {
  buildDatasetFlowFields,
  buildDatasetFlowWidgets,
  DatasetFlowFieldTemplate,
  DatasetFlowObjectFieldTemplate,
  enhanceDatasetFlowUiSchema,
  sanitizeUiSchema,
} from "../DatasetFormUI";
import "../AddDataset.scss";
import { CheckIcon } from "lucide-react";

var activeStep = 0;
var customUpload = false;
const S3_BUCKET = `${window.ENV.AWS_EXPORT_BUCKET}`;
const REGION = `${window.ENV.AWS_REGION}`;

// Keep Form stable across renders — recreating it remounts the select and closes the menu.
const registry = utils.getDefaultRegistry();
Theme.widgets["FileWidget"] = registry.widgets["FileWidget"];
Theme.widgets["RangeWidget"] = registry.widgets["RangeWidget"];
const Form = withTheme(Theme);

export default function Export({ datasetId, version_id, close }) {
  const setAlert = useContext(alertContext);
  const [schema, setSchema] = useState();
  const [uischema, setUischema] = useState();
  // Keep live form values in React state — without onChange sync, RJSF resets
  // selects/toggles whenever the parent re-renders (e.g. dataset polling).
  const [submited, setSubmited] = useState({});
  const [tempCredentials, setTempcredentials] = useState();
  // const { projectId } = useParams();
  const url = `forms/export_data?ds_version_id=${version_id}`;
  const { data, loading, error, setLoad, status } = useFetch(url, "get");
  const steps = data?.steppers;
  const totalSteps = steps?.length || 1;
  const currentStepLabel =
    steps?.[activeStep] || schema?.title || (schema?.configuration ? "Review" : "Export Details");
  const currentStepNumber = Math.min(activeStep + 1, totalSteps);
  const visibleHeaderSteps = steps?.length ? steps.slice(0, currentStepNumber) : [currentStepLabel];
  const isCustomUploadStep = schema && activeStep === 1 && customUpload == true;
  const showFormStep = schema && activeStep != steps?.length - 1 && customUpload != true;
  const [selectedFile, setSelectedFile] = useState();
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [formReady, setFormReady] = useState(false);
  const enhancedUiSchema = useMemo(
    () => enhanceDatasetFlowUiSchema(sanitizeUiSchema(uischema || {})),
    [uischema]
  );
  const widgets = useMemo(
    () => buildDatasetFlowWidgets(CustomWidget),
    []
  );
  const fields = useMemo(
    () => buildDatasetFlowFields(),
    []
  );
  const formContext = useMemo(
    () => ({ formData: submited, setFormData: setSubmited, schema }),
    [submited, schema]
  );
  const handleFormChange = ({ formData }) => {
    setSubmited(formData || {});
  };
  const handleFileInput = (e) => {
    setSelectedFile(e.target.files[0]);
  };
  const handleCustomScriptDrop = (e) => {
    e.preventDefault();
    setSelectedFile(e.dataTransfer.files?.[0]);
  };

  React.useEffect(() => {
    if (!data) return;
    activeStep = 0;
    customUpload = false;
    setUischema(data?.ui_schema);
    setSchema(data?.json_schema);
    // Seed from schema defaults once; do not wipe user edits on later parent renders.
    setSubmited((prev) =>
      prev && Object.keys(prev).length > 0 ? prev : {}
    );
    setFormReady(true);
    return () => {
      customUpload = false;
    };
  }, [data]);
  // console.log(uischema);
  const onSubmit = ({ formData }, e) => {
    e.preventDefault();
    setLoad(true);
    var test = { ...submited, ...formData };
    setSubmited(test);
    let cokkie = getCokkie("jwtToken");
    var myHeaders = new Headers();
    
    var urlencoded = JSON.stringify(test);
    var requestOptions2 = {
      method: "post",
      headers: myHeaders,
      body: urlencoded,
    };
    myHeaders.append("Authorization", `Bearer ${cokkie}`);
    myHeaders.append("accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    fetch(
      `${window["ENV"].API_URL}/forms/export_data?ds_version_id=${version_id}&step=${activeStep}`,
      requestOptions2
    )
      .then((response) => response.json())
      .then((result) => {
        setSchema(result?.summary ? result?.summary:result?.json_schema);
        setUischema(result?.ui_schema);
        setTempcredentials(result?.temp_aws_cred);
        if (result?.summary) {
          setSubmited(result?.json_schema?.summary);
          let temp = {};
          temp.configuration = result?.summary;

          console.log(tempCredentials);
          setSchema(temp);
        }
        if (activeStep == 0 && formData?.CustomScript == true) {
          customUpload = true;
        } else {
          customUpload = false;
          // window.alert("yes boy")
        }
        activeStep = result?.active_step ?? activeStep++;
      })

      .catch((e) => alert(e.message + " or Internal Server Error"))
      .finally((e) => setLoad(false));
    // console.log(schema);
  };
  const upload = (formData) => {
    setLoad(true);
    //customUpload = false;
    var test = { ...submited, ...formData };
    setSubmited(test);
    let cokkie = getCokkie("jwtToken");
    var myHeaders = new Headers();
    var urlencoded = JSON.stringify(test);
    var requestOptions2 = {
      method: "post",
      headers: myHeaders,
      body: urlencoded,
    };
    myHeaders.append("Authorization", `Bearer ${cokkie}`);
    myHeaders.append("accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    fetch(
      `${window["ENV"].API_URL}/forms/export_data?ds_version_id=${version_id}&step=${activeStep}`,
      requestOptions2
    )
      .then((response) => response.json())
      .then((result) => {
        setSchema(result?.json_schema ?? result?.summary);
        setUischema(result?.ui_schema);
        if (result.summary) {
          setSubmited(result.summary);
          let temp = {};
          temp.configuration = result?.summary;
          setSchema(temp);
          console.log(schema)
        }
        activeStep = result?.active_step ?? activeStep++;
      })

      .catch((e) => alert(e.message + " or Internal Server Error"))
      .finally((e) => setLoad(false));
    // console.log(schema);
  };
  const handleUpload = async (file) => {
    setUploading(true);
    var test = { ...submited };
    test.access_key = tempCredentials?.aws_access_key_id;
    test.secret_key = tempCredentials?.aws_secret_access_key;
    test.session_token = tempCredentials?.aws_session_token;
    test.bucket_name = S3_BUCKET;
    test.folder_name = file.name;
    console.log(test);
    const target = { Bucket: S3_BUCKET, Key: file.name, Body: file };
    try {
      const parallelUploads3 = new Upload({
        client: new S3Client({
          region: REGION,
          credentials: {
            accessKeyId: tempCredentials?.aws_access_key_id,
            secretAccessKey: tempCredentials?.aws_secret_access_key,
            sessionToken: tempCredentials?.aws_session_token,
          },
        }),
        leavePartsOnError: false, // optional manually handle dropped parts
        params: target,
      });

      parallelUploads3.on("httpUploadProgress", (progress) => {
        setUploaded(Math.round((progress?.loaded / progress?.total) * 100));
        if (progress?.loaded / progress?.total == 1) {
          // window.alert("yes boy")
          upload(test);
        }
      });

      await parallelUploads3.done(() => {
        window.alert("yes boy");
      });

      setUploading(false);
      setUploaded(true);
      // alert("File Uploaded!");
    } catch (e) {
      handleUpload(selectedFile);
    }
  };
  const back = (e) => {
    e.preventDefault();
    setLoad(true);
    console.log(submited?.CustomScript);
    console.log(customUpload);
    console.log(activeStep);
    activeStep = activeStep - (customUpload === true ? 2 : 3);
    console.log(activeStep);
    var test = { ...submited };
    let cokkie = getCokkie("jwtToken");
    var myHeaders = new Headers();
    var urlencoded = JSON.stringify(test);
    var requestOptions2 = {
      method: "post",
      headers: myHeaders,
      body: urlencoded,
    };
    myHeaders.append("Authorization", `Bearer ${cokkie}`);
    myHeaders.append("accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    setLoad(true);
    fetch(
      `${window["ENV"].API_URL}/forms/export_data?ds_version_id=${version_id}&step=${activeStep}`,
      requestOptions2
    )
      .then((response) => response.json())
      .then((result) => {
        setSchema(result?.summary? result?.summary :result?.json_schema);
                setUischema(result?.ui_schema);
        if (result?.summary) {
          setSubmited(result?.summary);
          let temp = {};
          temp.configuration = result?.summary;
          setSchema(temp);
        }
        activeStep = result?.active_step;
        if (activeStep == 0) customUpload = false;
        if (activeStep == 1) customUpload = true;
      })

      .catch((e) => alert(e.message + " or Internal Server Error"))
      .finally((e) => setLoad(false));
    // console.log(schema);
  };
  const final = (e) => {
    e.preventDefault();
    setLoad(true);
    var test = { ...schema.configuration };
    let cokkie = getCokkie("jwtToken");
    var myHeaders = new Headers();
    var urlencoded = JSON.stringify(test);
    var requestOptions2 = {
      method: "post",
      headers: myHeaders,
      body: urlencoded,
    };
    myHeaders.append("Authorization", `Bearer ${cokkie}`);
    myHeaders.append("accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    fetch(
      `${window["ENV"].API_URL}/forms/export_data?ds_version_id=${version_id}&step=${activeStep}`,
      requestOptions2
    )
      .then((response) => response.json())
      .then((result) => {
        setAlert(result.detail);
        close();
      })
      // .catch((e) => alert(e.message + " or Internal Server Error"))
      .finally((e) => setLoad(false));
  };
  if (loading && !formReady) return (
    <main className="open-form evaluate-model-ui h-100 d-flex flex-column dataset-flow-shell">
      <div className="dataset-flow-shell__loader">
        <Loader />
      </div>
    </main>
  );
  if (error) console.log(error);
  return (
    <main className="open-form evaluate-model-ui h-100 d-flex flex-column dataset-flow-shell position-relative">
      {loading && formReady && (
        <div className="dataset-flow-shell__loader dataset-flow-shell__loader--overlay">
          <Loader />
        </div>
      )}
      <header className="d-flex align-items-start justify-content-between p-3 dataset-flow-shell__header">
        <div className="d-flex gap-2 align-items-start w-100">
          <ExportIcon className="wf-icon-blue bg-primary text-white" />
          <div className="em-header flex-fill">
            <div className="d-flex justify-content-between w-100">
              <h2 className="main-header mb-0">Export Dataset Version</h2>
              <button className="plain-button2 p-0" onClick={() => close?.("")}>
                <CloseIcon className="wf-icon text-secondary" />
              </button>
            </div>
            <p className="sub-title mb-0">
              Step {currentStepNumber} of {totalSteps}: {currentStepLabel}
            </p>
          </div>
        </div>
      </header>

      <section className="dataset-wizard__card flex-fill w-100 dataset-flow-shell__body">
        <div className="form-shell__intro">
          <div className="dataset-flow-shell__eyebrow">
            <div className="dataset-flow-shell__step-flow">
              {visibleHeaderSteps.map((stepLabel, index) => {
                const stepNumber = index + 1;
                const isCurrentHeaderStep = stepNumber === currentStepNumber;

                return (
                  <div
                    key={`${stepLabel}-${stepNumber}`}
                    className="dataset-flow-shell__step-item"
                  >
                    {isCurrentHeaderStep ? (
                      <span className="dataset-flow-shell__step-badge">
                        Step {stepNumber}
                      </span>
                    ) : (
                      <span className="dataset-flow-shell__step-marker">
                        {stepNumber}
                      </span>
                    )}
                    <span
                      className={`dataset-flow-shell__step-name ${
                        isCurrentHeaderStep
                          ? "dataset-flow-shell__step-name--active"
                          : ""
                      }`}
                      style={{ color: "#b1c7e8" }}
                    >
                      {stepLabel}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
          <p className="mb-0" style={{ color: "#d6edff" }}>
            Configure the export options for this dataset version.
          </p>
        </div>

        {showFormStep ? (
          <Form
            id="export-dataset-version-form"
            schema={schema}
            uiSchema={enhancedUiSchema}
            widgets={widgets}
            fields={fields}
            formData={submited}
            onChange={handleFormChange}
            onSubmit={onSubmit}
            FieldTemplate={DatasetFlowFieldTemplate}
            ObjectFieldTemplate={DatasetFlowObjectFieldTemplate}
            formContext={formContext}
            showErrorList={false}
            liveValidate={false}
            omitExtraData={false}
            // Stable key per version so we don't remount (and clear) on every parent render
            key={`export-form-${version_id}-${formReady ? "ready" : "init"}`}
          >
            <button type="submit" className="d-none" aria-hidden="true" tabIndex={-1} />
          </Form>
        ) : schema ? (
          isCustomUploadStep ? (
            <div>
              <label className="form-label mt-0">Upload Custom Script</label>
              <div
                className="em-dropzone text-center d-a flex-column h-100 p-5"
                style={{
                  background: "transparent",
                  border: "2px dashed var(--glass-color)",
                  cursor: "pointer",
                }}
                onClick={() => document.getElementById("export-custom-script-upload")?.click()}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleCustomScriptDrop}
                role="button"
              >
                <UploadIcon className="em-drop-icon mb-2 wf-icon" />
                <p className="small-bold-text mb-0">
                  {selectedFile?.name || "Drag & Drop files"}
                </p>
                <p className="em-drop-subtext">or browse your computer</p>
              </div>
              <input
                id="export-custom-script-upload"
                type="file"
                className="d-none"
                onChange={handleFileInput}
              />
              {uploading && (
                <>
                  <div className="text-center mt-3">{uploaded} %</div>
                  <Progress value={uploaded} />
                </>
              )}
            </div>
          ) : (
            <div className="px-2">
              <Configuration expData={schema} />
            </div>
          )
        ) : (
          <ErrorScreen message={status == 403 ? data?.detail : "No form Found"} />
        )}
      </section>

      {schema && (
        <div className="dataset-footer">
          <div className="dataset-footer__actions">
            {activeStep ? (
              <Button
                type="button"
                color="secondary"
                className="mt-0 text-white py-2"
                onClick={back}
                disabled={loading}
              >
                <BackIcon className="wf-icon me-2 text-white" />
                Back
              </Button>
            ) : (
              <Button
                type="button"
                color="secondary"
                className="mt-0 text-white py-2"
                onClick={() => close?.("")}
                disabled={loading}
              >
                Cancel
              </Button>
            )}

            {showFormStep ? (
              <Button
                type="submit"
                form="export-dataset-version-form"
                color="primary"
                className="py-2 m-0 fw-bold"
                disabled={loading}
              >
                Next&nbsp;
                <ArrowRightIcon className="wf-icon text-white" />
              </Button>
            ) : isCustomUploadStep ? (
              <Button
                type="button"
                color="primary"
                className="py-2 m-0 fw-bold"
                onClick={() => handleUpload(selectedFile)}
                disabled={uploading || !selectedFile}
              >
                Upload&nbsp;
                <UploadIcon className="wf-icon text-white" />
              </Button>
            ) : (
              <Button
                type="button"
                color="primary"
                className="py-2 m-0 fw-bold"
                onClick={final}
                disabled={loading}
              >
                Submit&nbsp;
                <CheckIcon className="wf-icon text-white" />
              </Button>
            )}
          </div>
        </div>
      )}
    </main>
  );
}
